import React from 'react';
import './App.css';

import User from './Components/User/User';
import Result from './Components/Results/Result';

function App() {


  return (
    <div >   
    <Result></Result>  
          
    </div>
  );
}

export default App;
